// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d12c5173","455":"966924d9","460":"7d38f4bf","497":"a8364052","541":"abe5cfb6","687":"370c651e"}[chunkId] + ".chunk.js";
};